export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14827.53f78451.jpg";